/* eslint-disable */
import React from 'react'
import {message} from 'antd'
import {Link} from 'react-router-dom'
import JASPERREPORT from '../BaseComponent/JASPERREPORT'
import Select from 'react-select'
import http from '../Interceptor/Interseptor'
import REPORT_RETAIL from '../BaseComponent/REPORTRETAIL'
import Loader from '../loaders/loader'
import WAREHOUSE from '../BaseComponent/WAREHOUSE'
import {Checkbox} from 'antd'
class CurrnetDifference extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      warehouses: [],
      warehouseId: null,
      loading: false,
      complete: false
    }
  }
  componentDidMount() {
    http
      .get(`${WAREHOUSE.WAREHOUSE_TYPE_LIST_WAREHOUSE}`, {})
      .then((response) => {
        if (response.data.error == null) {
          var result = response.data.object
          for (let i = 0; i < result.length; i++) {
            result[i]['value'] = result[i].id
            result[i]['label'] = result[i].name + ' - ' + result[i].typePrimaryName
          }

          this.setState({
            warehouses: response.data.object
          })
        }
        // alert(JSON.stringify(response.data))
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  submit(e) {
    e.preventDefault()
  }

  getReport() {
    let warehouseId = this.state.warehouseId === null || this.state.warehouseId === '' ? '' : this.state.warehouseId.id
    JASPERREPORT(
      `report/jasper/warehouse-current-difference?warehouseId=${warehouseId}&complete=${this.state.complete}`
    )
  }

  changeWarehouse = (warehouseId) => {
    this.setState({warehouseId})
  }

  render() {
    return (
      <div className="rtl">
        <Loader show={this.state.loading} />
        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>گزارشات</li>
            <li>انبار</li>
            <li>گزارش لحظه ای موجودی اشتباه انبارهای چیدمان</li>
          </ul>
          <form className="verticalForm" onSubmit={this.submit.bind(this)}>
            <div className="headerVertical">
              <p>گزارش لحظه ای موجودی اشتباه انبارهای چیدمان</p>
            </div>

            <div className="formComponent">
              <label className="font-weight-bold">انبار :‌</label>
              <Select
                value={this.state.warehouseId}
                onChange={this.changeWarehouse}
                options={this.state.warehouses}
                isMulti={false}
                isClearable={true}
                placeholder={''}
                tabIndex="1"
              />
            </div>
            <div className="formComponent">
              <label className="hiddenLabel">sd</label>
              <Checkbox
                name="complete"
                tabIndex="4"
                checked={this.state.complete}
                onChange={() => this.setState({complete: !this.state.complete})}
              >
                همه
              </Checkbox>
            </div>

            <div className="formComponent">
              <button className="btn btn-info btn-block jasperBtn" onClick={this.getReport.bind(this)}>
                ساخت گزارش
              </button>
              <p className="errorText" id="errorText" />
            </div>
          </form>
        </div>
      </div>
    )
  }
}
export default CurrnetDifference
